import CreateTypeSmallGroup from './create_type_small_group'
import { connect } from 'react-redux'
import { formatMoney } from 'client/griffin'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getMaxLimitReachedSelector } from 'redux/selectors/cip'
import { getMinMaxAmount } from 'shared/helpers/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const minMaxAmount = getMinMaxAmount(campaign)
  const isGNCEnabled = state.flags.is_gnc_enabled
  const countryCode = state.country.country_code

  const formattedMaxGoalAmount = minMaxAmount.MAX_AMOUNT
    ? formatMoney(campaign.currency, minMaxAmount.MAX_AMOUNT, {
        removeTrailingZeros: true,
      })
    : ''

  const isCampaignLimitReached = getMaxLimitReachedSelector(state)
  return {
    countryCode,
    formattedMaxGoalAmount,
    isGNCEnabled,
    isCampaignLimitReached,
  }
}

export default connect(mapStateToProps)(CreateTypeSmallGroup)
